// src/components/ProfileMenu.jsx
import React, { useRef } from "react";

/* ───────── pequeños helpers ───────── */
const Divider = () => <div className="pm-separator" />;

const MenuItem = ({ icon, text, onClick }) => (
  <button onClick={onClick} className="pm-item">
    <i className={`bi ${icon}`} style={{ fontSize: 18 }} />
    <span>{text}</span>
  </button>
);

/* ───────── componente principal ───────── */
const ProfileMenu = ({
  avatarSrc,
  name,
  emailOrRole,
  credits = 1500,
  onUploadImage,
  onLogout,
}) => {
  const fileRef = useRef(null);
  const pickFile = () => fileRef.current?.click();

  return (
    <>
      <div className="pm-wrapper">
        {/* cabecera */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "8px 16px",
          }}
        >
          <img
            src={avatarSrc}
            alt="avatar"
            style={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <div style={{ lineHeight: 1.2 }}>
            <strong>{name?.trim().split(/\s+/).slice(0, 2).join(" ")}</strong>
            <div style={{ fontSize: 12, color: "#666" }}>{emailOrRole}</div>
          </div>
        </div>

        <Divider />

        {/* opciones */}
        <MenuItem icon="bi-person" text="Account" />
        <MenuItem icon="bi-upload" text="Subir foto" onClick={pickFile} />
        <input
          type="file"
          accept="image/png, image/jpeg"
          ref={fileRef}
          onChange={onUploadImage}
          style={{ display: "none" }}
        />
        <MenuItem icon="bi-gear" text="Settings" />
        <MenuItem icon="bi-book" text="Guide" />
        <MenuItem icon="bi-question-circle" text="Help" />

        <Divider />

        {/* plan */}
        <div
          style={{
            padding: "12px 18px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontWeight: 600 }}>Free Plan</div>
            <div style={{ fontSize: 12, color: "#666" }}>{credits} credits</div>
          </div>
          <button
            style={{
              padding: "6px 14px",
              fontSize: 12,
              fontWeight: 600,
              color: "#2563ff",
              background: "#F2F6FF",
              borderRadius: 6,
              border: 0,
              cursor: "pointer",
            }}
          >
            Upgrade
          </button>
        </div>

        <Divider />

        <MenuItem
          icon="bi-box-arrow-right"
          text="Sign Out"
          onClick={onLogout}
        />
      </div>
    </>
  );
};

export default ProfileMenu;
